// Test Cloud Function directly
import { getFunctions, httpsCallable } from 'firebase/functions';
import { createLogger } from './logger';

const logger = createLogger('TestCloudFunction');

/**
 * Test the Cloud Function directly to see if it's working
 */
export const testCloudFunctionDirectly = async (currentUser) => {
  if (!currentUser) {
    logger.warn('No current user available for testing');
    return;
  }

  try {
    logger.info('Testing Cloud Function directly...');
    
    const functions = getFunctions();
    const sendOrderStatusNotification = httpsCallable(functions, 'sendOrderStatusNotification');
    
    const testData = {
      userId: currentUser.uid,
      orderId: 'direct-test-' + Date.now(),
      status: 'test',
      message: 'Direct Cloud Function test from PackMyCart'
    };
    
    logger.info('Calling Cloud Function with data:', testData);
    
    const result = await sendOrderStatusNotification(testData);
    logger.info('Cloud Function result:', result.data);
    
    return result.data;
  } catch (error) {
    logger.error('Cloud Function test failed:', error);
    throw error;
  }
};

/**
 * Test if the Cloud Function is accessible
 */
export const testCloudFunctionAccess = async () => {
  try {
    const functions = getFunctions();
    logger.info('Cloud Functions instance created successfully');
    
    // Validate the function reference can be created
    void httpsCallable(functions, 'sendOrderStatusNotification');
    logger.info('Cloud Function reference created successfully');
    
    return { success: true, message: 'Cloud Function is accessible' };
  } catch (error) {
    logger.error('Cloud Function access test failed:', error);
    return { success: false, error: error.message };
  }
};

